import axiosLib from "axios";

// Axios Interceptor Instance
const axios = axiosLib.create({
  baseURL:
    process.env.REACT_APP_BACKEND_URL || "https://api.read2earn.cointribune.com",
  withCredentials: true,
  timeout: 10000, // 10 seconds timeout
  headers: {
    "Content-Type": "application/json",
  },
});

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (originalError) => {
    return Promise.reject(originalError.response.data);
  },
);

export default axios;
